import PuxPageDetails from "../../../global/components/PuxPageDetails/PuxPageDetails.vue";
import HttpMixin from "../../../global/mixins/HttpMixin";
import PermissionMixin from "../../../global/mixins/PermissionMixin";
import ContextPanel from "../../../global/components/ContextPanel/ContextPanel.vue";
import PanelComponents from "./PanelComponents";
import translate from "../../../global/directives/translate";
import Permission from "../../../global/components/Permission/Permission.vue";
import Modal from "../../../global/components/Modal/Modal.vue";
import {
  initModelFromList,
  toFormElementFromParameter,
} from "../../../global/functions/mappingForParameterToFormElement";
import {
  cloneDeep,
  forEach,
  get,
  isNil,
  isString,
} from "lodash-es";

// @vue/component
export default {
  name: "WorkflowfolgeserverfunktionenDetails",
  components: {
    ContextPanel,
    Permission,
    Modal,
    PuxPageDetails,
    ...PanelComponents,
  },
  directives: {
    translate,
  },
  mixins: [
    HttpMixin,
    PermissionMixin,
  ],
  data() {
    return {
      loading: true,
      reloading: undefined,
      serverfunktion: undefined,
      showConfirmModal: false,
      confirmOptions: undefined,
      confirmErrors: undefined,
      panels: [
        {
          label: "_TXT_SERVERFUNKTION_DETAILS_BASISDATEN_PANEL_HEADER_",
          icon: "glyphicon-list",
          active: true,
          pk: "serverfunktion",
          components: [
            {
              name: "NameUndModul",
              pk: "NameUndModul",
            },
            {
              name: "Konfiguration",
              pk: "Konfiguration",
            },
            {
              name: "Ausfuehrung",
              pk: "Ausfuehrung",
            },
          ],
        },
        {
          label: "_TXT_SERVERFUNKTION_DETAILS_VERWENDUNGEN_PANEL_HEADER_",
          icon: "glyphicon-table",
          active: false,
          pk: "verwendungen",
          components: [
            {
              name: "VerwendungList",
              pk: "VerwendungList",
            },
          ],
        },
      ],
    };
  },
  computed: {
    translationPageTitle() {
      return {
        text: "_PAGE_TITLE_SERVERFUNKTION_DETAILS_{{bez}}_",
        extra: { bez: get(this.serverfunktion, "wfs_bez", "") }
      };
    },

    translationHeader() {
      return {
        text: "_TXT_SERVERFUNKTION_DETAILS_HEADER_{{bez}}_",
        extra: { bez: get(this.serverfunktion, "wfs_bez", "") }
      };
    },

    translationBtnDelete() {
      return {
        title: "_BTN_SERVERFUNKTION_DETAILS_DELETE_TITLE_",
        text: "_BTN_SERVERFUNKTION_DETAILS_DELETE_LABEL_"
      };
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData({ reload } = {}) {
      this.reloading = reload;
      this.getHttp({
        url: `serverfunktionen/${ this.$stateParams.id }/`,
      }).then(
        response => {
          this.updateServerfunktion({ serverfunktion: response });
        }
      ).finally(
        () => {
          this.loading = false;
          this.reloading = false;
        }
      );
    },

    removeServerfunktion() {
      this.reloading = true;
      this.confirmErrors = undefined;
      this.deleteHttp({
        url: `serverfunktionen/${ this.$stateParams.id }/`,
      }).then(
        () => {
          this.addNotification({
            text: "_MSG_SERVERFUNKTION_DETAILS_DELETE_SUCCESS_{{bez}}_",
            extra: {
              bez: get(this.serverfunktion, "wfs_bez", "")
            },
          });
          this.closeConfirm();
          this.$goTo("root.workflowfolgeserverfunktionen");
        },
        err => {
          this.addNotification({
            text: "_MSG_SERVERFUNKTION_DETAILS_DELETE_ERROR_{{bez}}_",
            type: "error",
            extra: {
              bez: get(this.serverfunktion, "wfs_bez", "")
            }
          });
          if (isString(err.data)) {
            this.confirmErrors = { non_field_errors: err.data };
          } else {
            this.confirmErrors = err.data;
          }
        },
      ).finally(
        () => {
          this.reloading = false;
        }
      );
    },

    updateServerfunktion({ serverfunktion }) {
      const SERVERFUNKTION = cloneDeep(serverfunktion);
      if (!isNil(SERVERFUNKTION.config_in)) {
        const CONF = toFormElementFromParameter({ obj: SERVERFUNKTION.config_in }).list;
        const MODEL = initModelFromList({ list: CONF });
        forEach(SERVERFUNKTION.wfs_parameterin || {}, (item, key) => {
          if (!isNil(item)) {
            MODEL[key] = item;
          }
        });
        SERVERFUNKTION.wfs_parameterin = MODEL;
      }
      this.serverfunktion = SERVERFUNKTION;
    },

    confirmDeleteServerfunktion() {
      this.confirmOptions = {
        okClass: "btn btn-danger",
        title: "_TXT_SERVERFUNKTION_DETAILS_DELETE_HEADER_{{bez}}_",
        msg: "_TXT_SERVERFUNKTION_DETAILS_DELETE_BODY_{{bez}}_",
        extra: {
          bez: get(this.serverfunktion, "wfs_bez", "")
        },
        okLabel: "_BTN_DELETE_",
        okCallback: this.removeServerfunktion,
        cancelCallback: this.closeConfirm,
        loading: false,
      };
      this.showConfirmModal = true;
    },

    closeConfirm() {
      this.confirmOptions = undefined;
      this.showConfirmModal = false;
      this.confirmErrors = undefined;
    },
  },
};
